export const title = 'Sales';
import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.en.mdx';

Number of sales attributed to campaigns.

<CampaignAttributionDateNote />
